// extracted by mini-css-extract-plugin
export default {"msgM":"_9ae91ca1e3"};